export default "__VITE_ASSET__DjjX6SK4__"